'use client';
import React from 'react';
import { getAssetUrl } from '@utils/getAssetUrl';
import TabData from '../TabData';
import cn from './style.module.scss';

export default function Amenities(props: any) {
  const { t } = props;
  const tabContent = [
    {
      heading: t['yasTabOneHeading'],
      description: t['yasTabOneContent'],
      listElement: t['yasTabOneElement'],
      images: [{ url: props.themeImg.url }],
    },
    // You can add more tabs with different data here
  ];
  return (
    <div
      className={cn.amenitiesGRDWrapper}
      style={{
        backgroundImage: `url(${props.bgImg.url})`,
      }}
    >
      <TabData tabs={tabContent} />
    </div>
  );
}
